import { GET_CANDIDATE_COMMENTS, COMMENT_LOADING, REMOVE_LOADING } from "../actions/types";

const initialState = {
  comments: null,
  loading: false,
};

export default function (state = initialState, action) {
  switch (action.type) {
    case COMMENT_LOADING:
      return {
        ...state,
        loading: true,
      };

    case GET_CANDIDATE_COMMENTS:
      return {
        ...state,
        comments: action.payload,
        loading: false,
      };

    case REMOVE_LOADING:
      return {
        ...state,

        loading: false,
      };

    default:
      return state;
  }
}
